import type { Brand, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'products/brands';

export function getBrands(query: Brand.SearchQuery) {
    return api.get<Pagination<Brand>>(rootPath, query);
}

export function getBrand(id: number) {
    return api.get<Brand.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postBrand(data: Brand.CreateRequest) {
    return api.post<Brand>(rootPath, data);
}

export function putBrand(id: number, data: Brand.UpdateRequest) {
    return api.put<Brand>(`${rootPath}/${id}`, data);
}

export function deleteBrand({ id }: Brand.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
